// ==================== SERVICIO DE DOCUMENTOS DE MATERIALES ====================
// Funciones para interactuar con la API de documentos de materiales

import api from './api';

// ==================== OBTENER DOCUMENTOS DE UN MATERIAL ====================
export const obtenerDocumentosMaterial = async (materialId) => {
  try {
    const response = await api.get(`/documentos-materiales/material/${materialId}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener documentos del material:', error);
    throw error;
  }
};

// ==================== OBTENER DOCUMENTO ESPECÍFICO CON BASE64 ====================
export const obtenerDocumento = async (documentoId) => {
  try {
    const response = await api.get(`/documentos-materiales/${documentoId}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener documento:', error);
    throw error;
  }
};

// ==================== ELIMINAR DOCUMENTO ====================
export const eliminarDocumento = async (documentoId) => {
  try {
    const response = await api.delete(`/documentos-materiales/${documentoId}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar documento:', error);
    throw error;
  }
};

// ==================== OBTENER DOCUMENTOS POR PROYECTO ====================
export const obtenerDocumentosProyecto = async () => {
  try {
    const response = await api.get('/documentos-materiales');
    return response.data;
  } catch (error) {
    console.error('❌ Error al obtener documentos del proyecto:', error);
    console.error('Detalles del error:', error.response?.data);
    throw error;
  }
};

const documentosMaterialesService = {
  obtenerDocumentosMaterial,
  obtenerDocumento,
  eliminarDocumento,
  obtenerDocumentosProyecto
};

export default documentosMaterialesService;
